// frontend/src/constans.js
export const BASE_URL = process.env.NODE_ENV === 'development' ? '' : '';
export const PROJECTS_URL = '/api/projects';
export const LEADSOURCES_URL = '/api/leadsources';
export const REGIONS_URL = '/api/regions';
export const FUNNEL_SECTIONS_URL = '/api/funnel-sections';
export const BUILDING_PROJECT_URL = '/api/building-projects';
export const REPORTS_URL = '/api/reports';
export const REPORTS_SETTINGS_URL = '/api/report-settings';
export const TYPES_URL = '/api/types';
export const KINDS_URL = '/api/kinds';
export const STAGES_URL = '/api/stages';
export const HISTORY_URL = '/api/history';
export const NEWS_URL = '/api/news';
export const USERS_URL = '/api/users';
export const TSLINK_URL = '/api/tslink';
export const PSLINK_URL = '/api/pslink';
export const UPLOADS_URL = '/api/upload';
export const PRODUCTS_URL = '/api/products';
